import React, { useState, useEffect } from "react";
import { getToken, logout } from "./api";
import Login from "./components/Login";
import App from "./App";

export default function AppWrapper() {
  const [isAuthenticated, setAuthenticated] = useState(() => !!getToken());

  useEffect(() => {
    if (!getToken()) setAuthenticated(false);
  }, []);

  const handleLogout = async () => {
    await logout();
    setAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onSuccess={() => setAuthenticated(true)} />;
  }

  return <App onLogout={handleLogout} />;
}
